import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import LegacyLink from '../../Common/LegacyLink';
import EnabledFeature from '../../Decorators/enabledFeature';
import Zendesk from '../../Common/ZendeskLink';
import { track } from '../../../helpers/Tracking/Analytics';

export const PrimaryLinks = ({ showSearchLink }) => (
  <React.Fragment>
    {showSearchLink && [
      <li className="mobile-hidden">
        <Link to="/">Search</Link>
      </li>
    ]}
    <EnabledFeature name="primary_header_invest_link">
      <li className="mobile-hidden">
        <LegacyLink
          to="about/justpark-is-crowdfunding-2019/"
          onClick={() => track('click:web-nav:invest-in-justpark')}
        >
          Invest
        </LegacyLink>
      </li>
    </EnabledFeature>
    <li className="mobile-hidden">
      <LegacyLink to="about/">About</LegacyLink>
    </li>
    <li className="mobile-hidden">
      <LegacyLink to="car-park-management/">Car park management</LegacyLink>
    </li>
    <li className="mobile-hidden">
      <LegacyLink to="rent-out-a-parking-space/">
        Rent out your driveway
      </LegacyLink>
    </li>
  </React.Fragment>
);

const PrimaryNav = ({ showSearchLink, isStatic, renderPrimaryLinks }) => (
  <ul className="c-header__menu">
    {!renderPrimaryLinks && <PrimaryLinks showSearchLink={showSearchLink} />}
    <li className="mobile-hidden">
      <Zendesk isStatic={isStatic}>Help</Zendesk>
    </li>
  </ul>
);

export default PrimaryNav;

PrimaryLinks.propTypes = {
  showSearchLink: PropTypes.bool.isRequired
};

PrimaryNav.propTypes = {
  showSearchLink: PropTypes.bool.isRequired,
  isStatic: PropTypes.bool,
  renderPrimaryLinks: PropTypes.bool.isRequired
};

PrimaryNav.defaultProps = {
  isStatic: false
};
